import { render, staticRenderFns } from "./FacilityForm.vue?vue&type=template&id=4fb18886&scoped=true&"
import script from "./FacilityForm.vue?vue&type=script&lang=js&"
export * from "./FacilityForm.vue?vue&type=script&lang=js&"
import style0 from "./FacilityForm.vue?vue&type=style&index=0&id=4fb18886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb18886",
  null
  
)

export default component.exports